import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {ColumnMode, SortType} from "@swimlane/ngx-datatable";

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent  implements OnInit {

  nyitotthet = 1
  allomany

  columns = [{ name: 'Oktatási azonosító' }, { name: 'Name' }, { name: 'Gender' }];

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.getAllomany()
  }

  getAllomany(){
    this.http
      .get(
        '/api/nyilvantartas/allomany',
        {
          //headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.allomany = response

        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
  }

  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
}
